import MetricGridSkeleton from "@/components/Skeleton/MetricGridSkeleton";
import TableSkeleton from "@/components/Skeleton/TableSkeleton";

type ApplicantPageSkeletonProps = {
  metricCards?: number;
};

export default function ApplicantPageSkeleton({ metricCards = 3 }: ApplicantPageSkeletonProps) {
  return (
    <div className="flex flex-col" data-testid="applicant-page-skeleton">
      <MetricGridSkeleton cards={metricCards} layout="expanded" />
      <div className="pt-12" />
      <TableSkeleton columns={8} rows={6} />
    </div>
  );
}
